import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "progress" };
const _hoisted_2 = ["aria-valuemin"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProgressBar',
    props: {
        progress: {}
    },
    setup(__props) {
        const props = __props;
        const styleObject = computed(() => {
            return {
                width: props.progress * 100,
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "progress-bar progress-bar-striped progress-bar-animated",
                    style: _normalizeStyle(styleObject.value),
                    "aria-valuenow": "progress",
                    "aria-valuemin": __props.progress * 100,
                    "aria-valuemax": "100"
                }, null, 12, _hoisted_2)
            ]));
        };
    }
});
